<template>
  <div class="gp-indicating" :class="iClass">
    <template v-if="size == 'small'">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.75778 5.36318C6.19714 6.0493 4.67754 8.68132 5.36366 11.242C6.04978 13.8026 8.6818 15.3222 11.2424 14.6361C13.8031 13.9499 15.3227 11.3179 14.6366 8.7573C13.9504 6.19666 11.3184 4.67706 8.75778 5.36318ZM2.2727 12.0702C1.12917 7.80245 3.66183 3.41576 7.92955 2.27222C12.1973 1.12869 16.584 3.66135 17.7275 7.92907C18.871 12.1968 16.3384 16.5835 12.0707 17.727C7.80293 18.8706 3.41624 16.3379 2.2727 12.0702Z" fill="#E2E2E2" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.75778 5.36318C6.19714 6.0493 4.67754 8.68132 5.36366 11.242L2.2727 12.0702C1.12917 7.80245 3.66183 3.41576 7.92955 2.27222L8.75778 5.36318Z" fill="#A6A6A6" />
      </svg>
    </template>
    <template v-if="size == 'large'">
      <svg width="62" height="62" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M27.1177 16.5111C19.1157 18.6552 14.367 26.8803 16.5111 34.8823C18.6552 42.8843 26.8803 47.633 34.8823 45.4889C42.8842 43.3448 47.633 35.1197 45.4889 27.1177C43.3447 19.1157 35.1197 14.367 27.1177 16.5111ZM6.85182 37.4705C3.27828 24.1338 11.1928 10.4254 24.5295 6.85185C37.8661 3.27831 51.5746 11.1929 55.1481 24.5295C58.7217 37.8662 50.8071 51.5746 37.4704 55.1481C24.1338 58.7217 10.4254 50.8071 6.85182 37.4705Z" fill="#E2E2E2"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M27.1177 16.5111C19.1157 18.6552 14.367 26.8803 16.5111 34.8823L6.85182 37.4705C3.27828 24.1338 11.1928 10.4254 24.5295 6.85185L27.1177 16.5111Z" fill="#A6A6A6"/>
      </svg>

    </template>

  </div>
</template>

<script>
export default {
  name: "Indicating",
  props: {
    size: {
      type: String,
      default: "small"
    },
    iClass: String
  }
}
</script>

<style lang="scss" scoped>
.gp-indicating {
  position: relative;
  @include flex-center;
  cursor: default;
  svg {
    animation: rotate 0.5s infinite linear;
  }
}
</style>